import { makeStyles } from '@mui/styles';
import { Theme } from '@mui/material/styles';

const useStyles = makeStyles((theme: Theme) => ({
  ticketTemplateItem: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    border: '1px solid #00000038',
    margin: '5px 0px',
    padding: '5px 15px',
    borderRadius: '15px',
    fontWeight: 700,
    fontSize: 'medium',
    cursor: 'pointer',
    color: theme.palette.text.primary,
  },
  createTicket: {
    padding: '30px',
    fontSize: 'large',
    alignItems: 'center',
    fontWeight: 800,
    justifyContent: 'space-between',
    background: theme.palette.background.paper,
    margin: '20px auto',
    width: '50%',
    borderRadius: '15px',
  },
  ticketTemplateItemIcon: {
    transform: 'rotate(180deg)',
    '& svg': {
      '& path': {
        stroke: theme.palette.text.primary,
      },
    },
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: '10px',
    margin: '10px 0',
  },
  createTicketFormHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    fontWeight: 700,
  },
  createTicketTeams: {
    width: '50%',
    margin: '0 auto',
    padding: '30px',
    boxSizing: 'border-box',
    overflowY: 'auto',
    height: '100%',
    background: theme.palette.background.paper,
  },
  createTicketHeader: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: '20px',
  },
  text: {
    color: theme.palette.text.primary,
  },
}));

export default useStyles;
